import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorIcon from '@mui/icons-material/ErrorRounded';
import InfoIcon from '@mui/icons-material/InfoRounded';
import WarningIcon from '@mui/icons-material/WarningRounded';
import { SnackbarContent, Snackbar } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { green, amber, red, blue } from '@mui/material/colors';
import ColoredSnackbarConstants from './ColoredSnackbarConstants';

const styles = theme => ({
    success: {
        backgroundColor: green[600]
    },
    error: {
        backgroundColor: red[400]
    },
    info: {
        backgroundColor: blue[600]
    },
    warning: {
        backgroundColor: amber[800]
    },
    icon: {
        fontSize: 20,
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: 350,
        color: 'white'
    }
});

class ColoredSnackbar extends React.Component {
    state = { showSnackbar: false }

    componentDidUpdate(prevProps) {
        const { open, onClose, autoHideDuration } = this.props;

        if (open !== prevProps.open) {
            if (open) {
                this.setState({ showSnackbar: true }, () => {
                    this.timer = setTimeout(() => {
                        this.setState({ showSnackbar: false }, onClose);
                    }, autoHideDuration);
                });
            } else {
                clearTimeout(this.timer);
                this.setState({ showSnackbar: false }, onClose);
            }
        }
    }

    render() {
        const { showSnackbar } = this.state;
        const { classes, variant, message, action, anchorOrigin, autoHideDuration } = this.props;

        let icon = <CheckCircleIcon className={classes.icon}/>;
        let className = classes.success;
        if (variant === ColoredSnackbarConstants.SNACKBAR_ERROR) {
            icon = <ErrorIcon className={classes.icon}/>
            className = classes.error;
        } else if (variant === ColoredSnackbarConstants.SNACKBAR_INFO) {
            icon = <InfoIcon className={classes.icon}/>
            className = classes.info;
        } else if (variant === ColoredSnackbarConstants.SNACKBAR_WARNING) {
            icon = <WarningIcon className={classes.icon}/>
            className = classes.warning;
        }

        return (
            <Snackbar
                variant={variant}
                open={showSnackbar}
                anchorOrigin={anchorOrigin}
                autoHideDuration={autoHideDuration}
            >
                <SnackbarContent
                    className={className}
                    message={
                        <span className={classes.message} >
                            {icon}
                            {message}
                        </span>
                    }
                    action={action}
                />
            </Snackbar>
        );
    }
}

export default withStyles(ColoredSnackbar, styles);